import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind('[data-fancybox="images"]', {
  on: {
    close: () => {
      // Remove focus after modal is fully closed, just before DOM cleanup
      if (document.activeElement) {
        document.activeElement.blur();
      }
    },
  },
});
Fancybox.bind('[data-fancybox="case-blog"]', {
  on: {
    close: () => {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    },
  },
});
Fancybox.bind("[data-fancybox]", {
  on: {
    close: () => {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    },
  },
});
